import React from 'react';

export const Step = ({ children }) => (
  <>
    {children}
  </>  
);
